import * as React from 'react'
import { IconName, ICON_NAMES } from '../../types/icon-names'

interface IProps extends Omit<React.SVGAttributes<SVGSVGElement>, 'name' | 'role'> {
  name: IconName
  ariaHidden?: boolean
  role?: string
}

const SvgIcon = ({
  name,
  className,
  ariaHidden = true,
  role = 'presentation',
  width = 24,
  height = 24,
  fill = 'currentColor',
  ...rest
}: IProps): JSX.Element => {
  if (process.env.NODE_ENV !== 'production' && !ICON_NAMES.includes(name)) {
    console.warn(
      `[SvgIcon] Unknown icon name: "${name}". Check available names in frontend/types/icon-names.ts`
    )
  }

  return (
    <svg
      className={className}
      aria-hidden={ariaHidden}
      role={role}
      width={width}
      height={height}
      fill={fill}
      {...rest}
    >
      <use href={`/images/icons/sprite.svg#${name}`} />
    </svg>
  )
}

export default SvgIcon
